/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 17:27:05
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import LayoutNavbar from '@root/components/LayoutNavbar';
import PromotionsPackage from '@root/containers/Promotions';

const DefaultPackagePage = () => {
  return (
    <LayoutNavbar
      navbarProps={{
        title: 'Special Sale',
      }}
      className="promotions-container"
      containerStyle={{ overflow: 'hidden' }}
      isHomeIcon={false}
    >
      <PromotionsPackage />
    </LayoutNavbar>
  );
};

export default DefaultPackagePage;
